export const devEnvConfig = {
  DISABLED_CONSOLE_MSG: false,
  YOLO_BASE_URL: 'https://www.dev.frontend.yolorekt.finance',
  BASE_BRANCH: 'dev',

  WSB_REFERRAL_CODE: 'WSB:DEV',

  // CRYPTO
  APPROVED_CHAINS_IDS: [137],

  //BACKEND CONNECTION
  YOLO_API_BASE_URL: 'https://api.eu.dev.yolorekt.finance',
  BACKEND_SOCKET_URL: 'wss://feed-server.eu.dev.yolorekt.finance',
  GATEWAY_SOCKET_URL: 'wss://leveraged-trading-gateway.eu.dev.yolorekt.finance',
  CONTRACTS_VERSION: '35',
}
